import { useState, useEffect } from 'react'
import { Auth } from 'aws-amplify'
import axios from 'axios'
const PlantList = ({plantItem, setPlantData, setErrorMsg}) => {
  const [editCodeValue, setEditCodeValue] = useState(false)
  const [saving, setSaving] = useState(false)
  const [newPlantName, setNewPlantName] = useState(plantItem.plant_name)
  const [buttonLabel, setButtonLabel] = useState('Edit')

  useEffect(() => {
    setButtonLabel(editCodeValue ? 'Cancel' : 'Edit')
  }, [editCodeValue])

  const onEditClick = () => {
    setEditCodeValue(!editCodeValue)
    if (!editCodeValue) {
        setEditCodeValue(plantItem.plant_id)
    }
  }
  const savePlant = async (e) => {
    e.preventDefault()

    setSaving(true)
    setErrorMsg(null)
    let session = await Auth.currentSession()
    let jwt = session.getIdToken().getJwtToken()

    const updateType = 'update'
    axios
    .put(`${process.env.REACT_APP_API_URL}/plant`, {plantId: plantItem.plant_id, plantName: newPlantName, updateType}, 
    {headers: {Authorization: jwt}}
    )
    .then(response => {
        setSaving(false)
        if (response.data.error) {
            setErrorMsg(response.data.error)
        } 
        onEditClick()
        setPlantData(response.data.rows)
    }) 
    .catch(error => {
        console.log('The error is: ', error)
        setErrorMsg('Problem saving data: ', error)
        setSaving(false)
    })                 
}

  return (
    <tr key={plantItem.plant_id}>
        <td>
          {!editCodeValue && plantItem.plant_name}
          {editCodeValue &&
            <input 
            type="text"
            min="0"
            className="text-input__customer-add"
            name="plantName"
            value={newPlantName || ''}
            disabled={saving}
            onChange={e => setNewPlantName(e.target.value) } />
          }
        </td>
        <td>
          <button className="table-button__small" onClick={onEditClick} disabled={saving} >{buttonLabel}</button>
        </td>
        <td>
          <button className="table-button__small" onClick={savePlant} 
              disabled={saving || !editCodeValue || !newPlantName} >Save
          </button>
        </td>
    </tr>
  )
}

export default PlantList